import { Grid } from "@material-ui/core";
import React from "react";
import MobileExplore from "../mobile/MobileExplore";
import MobileSummaryCard from "ui-component/cards/mobile/MobileSummaryCard";

const ExploreLayout = () => {
  return (
    <Grid container spacing={1.0}>
      <Grid item xs={12} alignItems="center"/>
      <Grid item spacing={0} xs={12}>
        <MobileSummaryCard sx={{ alignItems: "middle" }} />
      </Grid>

      <Grid item xs={12} alignItems="center">
        <MobileExplore />
      </Grid>

    </Grid>
  );
};

export default ExploreLayout;
